// Collection grid: loads the next page of products when the shopper scrolls near the end of the grid.
// Without JavaScript the "Load more" link still goes to the next page.
if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('[data-infinite-scroll-link]');
        this.link?.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadNextPage();
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
          },
          // Also counts as "reached" when the shopper jumped past it (e.g. straight to the footer)
          { rootMargin: '10000px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async loadNextPage() {
        const nextUrl = this.dataset.nextUrl;
        const grid = document.getElementById('product-grid');
        if (!nextUrl || !grid || this.isLoading) return;

        this.isLoading = true;
        this.setAttribute('loading', '');

        try {
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', grid.dataset.id);
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);

          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const newItems = document.createElement('div');
          page.querySelectorAll('#product-grid > .grid__item').forEach((item) => newItems.append(item));
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(newItems);
          grid.append(...newItems.children);

          const nextPage = page.querySelector('infinite-scroll')?.dataset.nextUrl;
          if (!nextPage) {
            this.remove();
            return;
          }
          this.dataset.nextUrl = nextPage;
          if (this.link) this.link.href = nextPage;
        } catch (error) {
          // The "Load more" link stays usable if a page fails to load
          this.setAttribute('error', '');
          return;
        } finally {
          this.isLoading = false;
          this.removeAttribute('loading');
        }

        // Still in view after a short page: observe again so the next page loads too
        this.observer.unobserve(this);
        this.observer.observe(this);
      }
    }
  );
}
